<template>
	<div>
		<v-card style="overflow:hidden" class="card ma-2" elevation="3">
			<div class="checkouted-mark" v-if="data.isCheckouted">تسویه شده</div>
			<div class="checkouted-mark" v-if="data.isCanceled">فسخ شده</div>
			<v-row>
				<v-col cols="12" sm="4">
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title class="headline mb-3 pb-2 secondary--text" style="border-bottom: 1px dashed rgb(191 191 191);">
								<span class="black--text">نوع وام:</span> {{ data.loanModel.title }}
							</v-list-item-title>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">شماره وام:</span>
								{{ data.code }}
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">شماره فرعی:</span>
								{{ data.secondaryCode || 'ندارد' }}
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">تاریخ شروع:</span>
								{{ data.startDate_Persian.date }}
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">مبلغ وام:</span>
								{{ data.amount.toString().toPriceFormat() }} تومان
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">باز پرداخت با بهره:</span>
								{{ data.payableAmount.toString().toPriceFormat() }} تومان
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">تعداد اقساط:</span>
								{{ data.month }} {{ (data.monthGap > 1 ? `قسط ${data.monthGap} ماهه` : "") }}
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">مبلغ هر قسط:</span>
								{{ data.installment.toString().toPriceFormat() }} تومان
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">مبلغ پیش پرداخت:</span>
								{{ data.preDepositAmount.toString().toPriceFormat() }} تومان
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

				</v-col>
				<v-col cols="12" sm="4">
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
								بازپرداخت ها
							</v-list-item-title>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">
									تعداد اقساط پرداختی:
								</span>
								{{ data.paidCount }}
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text">
								<span class="black--text">اقساط پرداخت شده:</span>
								{{ data.paid.toString().toPriceFormat() }} تومان
							</v-list-item-subtitle>
							<v-list-item-subtitle>
								<span v-if="data.delays === 0" class="">دیرکرد/زودکرد:</span>
								<span v-else-if="data.delays > 0" class="black--text">دیرکرد:</span>
								<span v-else class="black--text">زودکرد:</span>
								<span class="mr-1" :class="data.delays > 0 ? 'red--text' : data.delays < 0 ? 'success--text' : ''">{{ Math.abs(data.delays).toString().toPriceFormat() }} تومان</span>
							</v-list-item-subtitle>
							<v-list-item-subtitle class="">
								<span :class="[data.discount === 0 ? '' : 'black--text']">
									تخفیف:
								</span>
								<span :class="[data.discount === 0 ? '' : 'secondary--text']">{{ data.discount.toString().toPriceFormat() }} تومان</span>
								<v-btn text small color="info" class="mr-1" @click="showDiscount()"> ثبت تخفیف </v-btn>
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ
									باقیمانده:</span>
								{{ Math.abs(data.remain).toString().toPriceFormat() }} تومان <span class="success--text" v-if="data.remain < 0">بستانکار</span><span class="red--text" v-if="data.remain > 0">بدهکار</span>
							</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text"><span class="black--text">تسویه شده:</span>
								{{
									data.isCheckouted ? 'بلی' : 'خیر' }}</v-list-item-subtitle>
							<v-list-item-subtitle class="secondary--text" v-if="data.isCheckouted">
								<span class="black--text">تاریخ تسویه:</span> {{ data.checkoutDate_Persian.date }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

				</v-col>
				<v-col cols="12" sm="4">
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
								توضیحات:
							</v-list-item-title>
							<div style="white-space: pre-line;">
								{{ data.description ? data.description : 'توضیحاتی ثبت نشده است.' }}
							</div>
						</v-list-item-content>
					</v-list-item>

					<v-list-item three-line class="mt-3">
						<v-list-item-content>
							<v-list-item-title class="headline mb-3 pb-2" style="border-bottom: 1px dashed rgb(191 191 191);">
								نماینده:
							</v-list-item-title>
							<div style="white-space: pre-line;">
								{{ data.agentModel ? data.agentModel.businessName : 'بدون نماینده' }}
							</div>
							<div v-if="data.agentModel">
								سهم نماینده: {{ data.agentPrice.toString().toPriceFormat() }}
							</div>
						</v-list-item-content>
					</v-list-item>
				</v-col>
			</v-row>

			<v-card-actions class="flex-wrap">
				<v-btn outlined rounded text @click="showInstallments()" v-if="showInstallmentsBtn">
					مشاهده اقساط و پرداخت
				</v-btn>
				<v-btn outlined rounded text @click="showAssurances()" v-if="area === 'admin'">
					تضامین
				</v-btn>
				<v-btn outlined rounded text @click="showCheckoutAmount()">
					مشاهده مبلغ تسویه آنی
				</v-btn>
				<v-btn :disabled="!checkPermission('Cancel_Loan')" outlined rounded text @click="cancelLoan()" v-if="area === 'admin'">
					فسخ قرارداد
				</v-btn>
				<v-spacer />
				<v-btn class="mx-1" fab small color="secondary" title="ویرایش وام" @click="edit()" v-if="area === 'admin'">
					<v-icon>
						mdi-square-edit-outline
					</v-icon>
				</v-btn>
				<v-btn :disabled="!checkPermission('Delete_Loan')" class="mx-2" fab small dark color="pink" title="حذف وام" @click="remove()">
					<v-icon dark>
						mdi-trash-can-outline
					</v-icon>
				</v-btn>
				<v-btn v-if="checkActivePart('thirdParty') && area === 'admin'" class="mx-1" fab small outlined color="primary" @click="() => { dialogThirdParty = true }" title="ارتباط با دیگر نرم افزار ها">
					<v-icon>
						mdi-apache-kafka
					</v-icon>
				</v-btn>
				<v-btn class="mx-1" color="primary" title="پیامک های ثبت پرونده" v-if="area === 'admin'" fab outlined small @click="showSmsOperation()">
					<v-icon>mdi-chat-outline</v-icon>
					<v-badge :content="data.appSmsList ? data.appSmsList.length + '' : '0'" top color="secondary lighten-2" offset-x="15" offset-y="-7">
					</v-badge>
				</v-btn>
				<v-menu class="" v-if="['Default Customer', 'طلای سیف زاده'].includes(customerName)">
					<template v-slot:activator="{ on, attrs }">
						<v-btn fab dark small outlined color="primary" :loading="printLoading" v-bind="attrs" v-on="on" class="mx-1">
							<v-icon dark>
								mdi-printer-outline
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item link>
							<v-list-item-title @click="print(1)">چاپ قرارداد طلای اقساطی</v-list-item-title>
						</v-list-item>
						<v-list-item link>
							<v-list-item-title @click="print(2)">چاپ قرارداد قرض گروهی</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-btn v-else @click="print(3)" fab dark small outlined color="primary" :loading="printLoading" class="mx-1">
					<v-icon dark>
						mdi-printer-outline
					</v-icon>
				</v-btn>
			</v-card-actions>
			<slot></slot>
		</v-card>

		<div :id="'printHtml2_' + data.id" style="display: none;">
			<userLoan-printHtml v-if="data && printToggler && printType === 1" @ready="applyPrintReady()" :userLoanId="data.id" />
			<userLoan-printHtml2 v-if="data && printToggler && printType === 2" @ready="applyPrintReady()" :userLoanId="data.id" />
			<userLoan-default-printHtml v-if="data && printToggler && printType === 3" @ready="applyPrintReady()" :userLoanId="data.id" />
		</div>

		<v-dialog v-model="dialogAssurance" scrollable persistent max-width="900px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تضامین</span></div>
					<v-spacer />
					<v-btn @click="dialogAssurance = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<Assurance ref="assurance" v-if="dialogAssurance" :data="data" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogCheckoutAmount" max-width="400px">
			<v-card>
				<v-card-title>
					<div></div>
				</v-card-title>
				<v-container>
					<div v-if="checkoutAmount === checkoutAmount2">
						<div style="text-align: center;">
							<div class="mb-2">مبلغ قابل تسویه</div>
							<h3 :class="[checkoutAmount > 0 ? 'red--text' : 'success--text']">
								{{ checkoutAmount.toString().toPriceFormat() }} <span v-if="!isNaN(checkoutAmount)">{{ checkoutAmount > 0 ? 'بدهکار' : 'بستانکار' }}</span>
							</h3>
						</div>
					</div>
					<div v-else>
						<div style="text-align: center;border-bottom: 1px dashed #ddd;padding-bottom: 5px;margin-bottom: 5px;">
							<div class="mb-2">مبلغ قابل تسویه با کسر ضریب زودکرد</div>
							<h3 :class="[checkoutAmount > 0 ? 'red--text' : 'success--text']">
								{{ checkoutAmount.toString().toPriceFormat() }} <span v-if="!isNaN(checkoutAmount)">{{ checkoutAmount > 0 ? 'بدهکار' : 'بستانکار' }}</span>
							</h3>
						</div>
						<div style="text-align:center">
							<div class="mb-2">مبلغ قابل تسویه با کسر بهره ماهانه</div>
							<h3 :class="[checkoutAmount2 > 0 ? 'red--text' : 'success--text']">
								{{ checkoutAmount2.toString().toPriceFormat() }} <span v-if="!isNaN(checkoutAmount2)">{{ checkoutAmount2 > 0 ? 'بدهکار' : 'بستانکار' }}</span>
							</h3>
						</div>
					</div>
				</v-container>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="dialogCheckoutAmount = false">
						بستن
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogDiscount" max-width="400px">
			<v-card v-if="dialogDiscount">
				<v-form ref="discountForm" class="" lazy-validation @submit.prevent="submitDiscount">
					<v-card-title>
						<div>ثبت مبلغ تخفیف</div>
					</v-card-title>
					<v-divider></v-divider>
					<v-container>
						<v-row>
							<v-col cols="12" class="px-4">
								<div class="grey--text mb-1"><small class="pointer" @click="discount = data.delays">{{ data.delays >= 0 ? 'دیرکرد:' : 'زودکرد:' }} {{ data.delays.toString().toPriceFormat() }}</small></div>
								<v-text-money ref="amount" v-model="discount" label="مبلغ تخفیف را وارد کنید:" :error-messages="errorMessages" :rules="[() => discount >= 0 || 'مبلغ تخفیف را به صورت صحیح وارد کنید']" required />
							</v-col>
						</v-row>
					</v-container>
					<v-card-actions>
						<v-spacer />
						<v-btn @click="dialogDiscount = false">
							بستن
						</v-btn>
						<v-btn color="blue" dark :loading="submitDiscountLoading" type="submit">
							ذخیره
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogThirdParty" scrollable persistent>
			<v-card>
				<v-card-title>
					<span class="headline">ارتباط با دیگر نرم افزارها</span>
					<v-spacer />
					<v-btn @click="dialogThirdParty = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<thirdParty v-if="dialogThirdParty" @callbck="callbck_thirdParty" :entityType="'UserLoan'" :entityId="data.id" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogModifyUserLoan" scrollable persistent max-width="600px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyUserLoan = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-user-loan ref="modifyUserLoan" v-if="dialogModifyUserLoan" :data="data" @callbck="callbck_userLoan" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<app-sms-detail ref="appSmsDetail" :entityId="data.id" :data="data.appSmsList || []" :hideTypesBadge="true" type="NewUserLoan" />

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { cloneDeep } from 'lodash'
	import ModifyUserLoan from '@/views/admin/ModifyUserLoan.vue'
	import { get } from 'vuex-pathify'

	export default {
		name: 'ManageLoanItemView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			Assurance: () => import('@/components/forms/Assurance.vue'),
			'thirdParty': () => import('@/views/admin/ThirdParty.vue'),
			'Assurances': () => import('@/views/admin/Report/Assurances.vue'),
			'userLoan-printHtml': () => import('@/components/prints/UserLoanPrintHtml'),
			'modify-user-loan': ModifyUserLoan,
			'userLoan-printHtml2': () => import('@/components/prints/UserLoanPrintHtml2'),
			'userLoan-default-printHtml': () => import('@/components/prints/DefaultUserLoanPrintHtml'),
			'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
		},
		props: {
			data: { type: Object },
			area: { type: String, default: 'admin' },
			showInstallmentsBtn: { type: Boolean, default: true }
		},
		data() {
			return {
				loading: false,
				submitDiscountLoading: false,
				errorMessages: '',
				discount: 0,
				checkoutAmount: 0,
				checkoutAmount2: 0,
				dialogModifyUserLoan: false,
				dialogCheckoutAmount: false,
				dialogDiscount: false,
				dialogAssurance: false,
				dialogThirdParty: false,
				loans: [],
				printReady: false,
				printType: 0,
				printLoading: false,
				printToggler: false
			}
		},
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			customerName() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer) { return `${user.userData.customer.name}` }
				return ''
			},
		},
		mounted() {

		},
		methods: {
			edit() {
				this.dialogModifyUserLoan = true
			},
			showDiscount() {
				this.discount = this.data.discount
				this.dialogDiscount = true
			},
			async remove() {
				if (!this.data) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/userloan/delete/' + this.data.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.$emit('loadData')
								this.$emit('removed')
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			async cancelLoan() {
				if (!this.data) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از فسخ این قرارداد مطمئن هستید؟ دقت شود پس از فسخ قرارداد، کلیه اقساط تعریف شده برای این پرونده حذف می گردد و مانده وام صفر می شود و غیر قابل بازگشت می باشد.',
				)) {
					api.post('admin/userloan/SetAsCanceled/' + this.data.id)
						.then(
							response => {
								toast.success('قرارداد با موفقیت فسخ شد.')
								this.$emit('loadData')
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			showInstallments() {
				this.$emit('showInstallments', this.data)
			},
			showCheckoutAmount() {
				this.dialogCheckoutAmount = true
				this.checkoutAmount = "در حال دریافت اطلاعات..."
				this.checkoutAmount2 = "در حال دریافت اطلاعات..."
				api.get(`${this.area}/userloan/getCheckoutAmount/` + this.data.id, null)
					.then(
						response => {
							this.checkoutAmount = response.item1
							this.checkoutAmount2 = response.item2
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			showAssurances() {
				this.dialogAssurance = true
			},
			callbck_userLoan(result) {
				this.dialogModifyUserLoan = false
				if (result) {
					this.$emit('loadData')
				}
			},
			callbck_thirdParty() {
				this.dialogThirdParty = false
			},
			submitDiscount() {
				if (!this.$refs.discountForm.validate()) { return }
				let data = { id: this.data.id, discount: this.discount }
				this.submitDiscountLoading = true
				api.post('admin/userloan/SetDiscount', data)
					.then(
						response => {
							this.dialogDiscount = false
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.$emit('loadData')
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitDiscountLoading = false })
			},
			applyPrintReady() {
				this.printReady = true
			},
			print(type) {
				this.printReady = false
				this.printLoading = true
				this.printToggler = false
				this.printType = 0
				setTimeout(() => {
					let timer = 0
					this.printToggler = true
					this.printType = type
					let interval = setInterval(() => {
						timer++
						if (timer > 300 || this.printReady) {
							clearInterval(interval)
							this.printLoading = false
						}
						if (this.printReady)
							printJS({
								printable: 'printHtml2_' + this.data.id,
								type: 'html',
								scanStyles: false, // If true inline styles will be removed
								targetStyles: ['*'],
								style: `
										@font-face {
											font-family:'YekanP';
											src:url(/iranyekanweb.ttf) format('truetype'),
											url(/iranyekanweb.woff) format('woff-variations'),
											url(/iranyekanweb.woff) format('woff'),
											url(/iranyekanweb.woff2) format('woff2');
											font-display:fallback
										}
										#printHtml2_${this.data.id} {
												display: block !important;
												font-family: 'YekanP', sans-serif;
										}
									`
							})
						setTimeout(() => {
							this.printToggler = false
						}, 3000)
					}, 100)
				}, 100)
			},
			showSmsOperation() {
				this.$refs.appSmsDetail.showOperationByTypeName('NewUserLoan')
			},
		},
	}
</script>
<style>

	.v-tabs.hide .v-tabs-bar,
	.v-tabs.hide .can-hide,
	.v-tabs.hide .v-tabs-slider-wrapper {
		display: none !important;
		height: 0px;
	}

	.v-tabs.hide .v-tabs-bar {
		display: none !important;
		height: 0px;
	}
</style>
